"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("../../constant");

var _constant3 = require("../constant");

var _default = {
  PropTypes: {
    theme: _propTypes.string,
    viewport: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    locale: _propTypes.string,
    currency: _propTypes.string,
    selectedOrigin: _propTypes.func,
    prefillStation: _propTypes.string,
    prefillDestination: _propTypes.string,
    openCalendarFromPlacePicker: _propTypes.func,
    fireGtm: _propTypes.func,
    showIconBackground: _propTypes.bool,
    originOrDestinationNotFoundEventHandler: _propTypes.func,
    gtmParameters: (0, _propTypes.shape)({
      appName: _propTypes.string
    }),
    cityLevelGrouping: _propTypes.bool,
    useV3Bucket: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    viewport: _constant2.DEVICE_TYPE.DESKTOP,
    locale: _constant3.DEFAULT_LOCALE,
    currency: _constant3.DEFAULT_CURRENCY,
    showIconBackground: false,
    cityLevelGrouping: false,
    useV3Bucket: false
  }
};
exports.default = _default;